import nazaExploracion from "@/assets/mascot/naza-exploración.webp";
import santiChill from "@/assets/mascot/santi-chill.webp";
import loreCalma from "@/assets/mascot/lore-calma.webp";
import robertEnergia from "@/assets/mascot/robert-energía.webp";
import luConcentracion from "@/assets/mascot/lu-concentración.webp";
import facuPasion from "@/assets/mascot/facu-pasión.webp";
import defaultMascot from "@/assets/mascot/default-mascot.webp";

export const DEFAULT_MASCOT_SRC = defaultMascot;

export const MASCOT_IDS =
    [
        "Exploración",
        "Chill",
        "Calma",
        "Energía",
        "Concentración",
        "Pasión"
    ] as const;

export type MascotId = typeof MASCOT_IDS[number];

export interface Mascot {
    id: MascotId;
    label: string;
    mood: string;
    src: string;
};

export const MASCOT_CATALOG: readonly Mascot[] = [
    {
        id: "Concentración",
        label: "Lu",
        mood: "Concentración",
        src: luConcentracion,
    },
    {
        id: "Pasión",
        label: "Facu",
        mood: "Pasión",
        src: facuPasion,
    },
    {
        id: "Exploración",
        label: "Naza",
        mood: "Exploración",
        src: nazaExploracion,
    },
    {
        id: "Energía",
        label: "Robert",
        mood: "Energía",
        src: robertEnergia,
    },
    {
        id: "Calma",
        label: "Lore",
        mood: "Calma",
        src: loreCalma,
    },
    {
        id: "Chill",
        label: "Santi",
        mood: "Chill",
        src: santiChill,
    }
];
